import React, { useEffect } from "react";

import { Modal, Button, Header } from "semantic-ui-react";
import "./MissingSkuWarningModal.css";
import SharedFunctions from "../../utils/SharedFunctions";
import { MISSING_SKU_WARNING_MODAL } from "../../utils/constants/componentConstants";

const MissingSkuWarningModal = ({ open, onClose, onAccept, header, children }) => {
  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(MISSING_SKU_WARNING_MODAL);
    }
    if (open) {
      onOpen();
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} size="small" className="MissingSkuWarningModal">
      <Header icon="warning sign" color="red" content={header} />
      <Modal.Content>{children}</Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={onClose} autoFocus float={"left"}>
          AVBRYT
        </Button>
        <Button primary onClick={onAccept} autoFocus>
          JA
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default MissingSkuWarningModal;
